import axios from "axios";
import Result from "../../utils/serviceResultPattern";

export default {
  openReservationById(supplierId, reservationId) {
    return axios
      .get("api/reservation/FindReservationBySupplier", {
        params: { supplierId, reservationId },
      })
      .then((res) => {
        if (!res || res.status !== 200 || !res.data) {
          return Result.error("We couldn't load the reservation at this time. Please try again or contact support if the issue persists.");
        }
        return Result.ok(res.data);
      })
      .catch((error) => {
        return Result.error(error);
      });
  },
  editReservation(payload, cancelToken) {
    return axios
      .post("/api/reservation/ReservationEdit", payload, { cancelToken });
  },
  exportReservations(url, payload) {
    return axios
      .get(url, { params: payload, responseType: 'blob' })
      .then((res) => {
        if (!res || res.status !== 200) {
          return Result.error('We couldn\'t export the reservations at this time. Please try again or contact support if the issue persists.');
        }

        const rawFilename = (res.headers['content-disposition'] || '').split('filename=')[1] || '';
        const filename = rawFilename.split(';')[0].trim().replace(/"/g, '');

        return Result.ok({ blob: new Blob([res.data], { type: res.headers['content-type'] }), filename });
      })
      .catch((error) => {
        return Result.error(error);
      });
  }
};


// WEBPACK FOOTER //
// ./src/api/reservation/reservationService.js